// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier,signInWithPhoneNumber , browserLocalPersistence,setPersistence } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

import {
  getFirestore,
  collection,
  addDoc,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  arrayUnion,
} from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4IQ0dXq7h1D8b0k59f0EoVnl95qA8cpQ",
  authDomain: "ttds-d11e9.firebaseapp.com",
  projectId: "ttds-d11e9",
  storageBucket: "ttds-d11e9.firebasestorage.app",
  // storageBucket: "ttds-d11e9.appspot.com", // ✅ Corrected this line
  messagingSenderId: "5284238230",
  appId: "1:5284238230:web:ac1831d320f16c17e143b7",
  measurementId: "G-72ME0KP8PF",
  databaseURL: "https://ttds-d11e9-default-rtdb.firebaseio.com", // ✅ Add this line
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);

const secondaryApp = initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);
const db = getFirestore(app);
const rtdb = getDatabase(app);


setPersistence(auth, browserLocalPersistence);


// Export everything needed
export {
  db,
  rtdb,
  // auth,
  secondaryAuth,
  googleProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber ,
  storage,
  collection,
  addDoc,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  arrayUnion,
};

// Optional helper function
// export const saveSevakData = async (formData) => {
//   const sevakRef = collection(db, 'groups');
//   return await addDoc(sevakRef, formData);
// };
// firebase.js
export const createSevakGroup = async (groupName) => {
  /* returns groupId */
};
export const saveSevakData = async (groupId, sevakData) => {
  /* saves under groupId */
};
export const deleteSevakFromGroup = async (groupId, adharId) => {
  /* deletes one sevak */
};

googleProvider.setCustomParameters({
  prompt: "select_account",
});
